export const signUpGtm = (clicked_button: string) => {
  dataLayer.push({
    event: 'ga4Event',
    event_name: 'sign_up_click',
    clicked_button: clicked_button,
  });
};

export const loginSuccessGtm = () => {
  dataLayer.push({
    event: 'ga4Event',
    event_name: 'login',
  });
};

export const signUpSuccessGtm = () => {
  dataLayer.push({
    event: 'ga4Event',
    event_name: 'sign_up',
  });
};

export const signUpStepGtm = (step: string) => {
  dataLayer.push({
    event: 'ga4Event',
    event_name: 'sign_up_step',
    step: step,
  });
};

export const resendCodeGtm = (step?: string) => {
  dataLayer.push({
    event: 'ga4Event',
    event_name: 'resend_sms_code',
    verification_place: step,
  });
};
